import { createSlice } from '@reduxjs/toolkit';

const jobTitleSlice = createSlice({
  name: 'jobTitle',
  initialState: {
    jobTitleListArray: [],
    isSuccess: false,
  },
  reducers: {
    createJobTitle: state => {
      state.isSuccess = false;
    },
    createJobTitleSuccess: (state, payload) => {
      state.isSuccess = true;
    },
    createJobTitleFail: state => {
      state.isSuccess = false;
    },
    deleteJobTitle: () => {},
    deleteJobTitleSuccesse: (state, payload) => {},
    deleteJobTitleFail: state => {},
    updateJobTitleList: (state, { payload }) => {
      const newData = {
        compStrcCd: payload.compStrcCd,
        compStrcCdNm: payload.compStrcCdNm,
      };
      const _jobTitleListArray = state.jobTitleListArray;
      _jobTitleListArray.push(newData);
      state.jobTitleListArray = _jobTitleListArray;
      state.isSuccess = true;
    },
    removeJobTitleList: (state, { payload }) => {
      const _jobTitleListArray = state.jobTitleListArray.filter(item => item.compStrcCd !== payload.id);
      state.jobTitleListArray = _jobTitleListArray;
    },
  },
});

export const {
  createJobTitle,
  createJobTitleSuccess,
  createJobTitleFail,
  deleteJobTitle,
  deleteJobTitleSuccesse,
  deleteJobTitleFail,
  updateJobTitleList,
  removeJobTitleList,
} = jobTitleSlice.actions;
export default jobTitleSlice.reducer;
